import { markNames } from '../../constants/marks';
import { dspxDiffDays } from '../../../../helpers/dspx-utils';

const increaseValue = (map, name) => {
  const item = map.get(name);
  map.set(name, { ...item, value: item.value + 1 });
};

export const generateMarks = (request, map) => {
  const diff = request.doneDate
    ? dspxDiffDays(request.doneDate, request.executeTime)
    : dspxDiffDays(0, request.executeTime);

  if (request.hasRecord) {
    increaseValue(map, markNames.hasRecord);
  }

  if (request.hasAttachment) {
    increaseValue(map, markNames.hasAttachment);
  }

  if (!request.garanty || request.garantyId === 0) {
    increaseValue(map, markNames.noWarranty);
  }
  if (request.garantyId === 1) {
    increaseValue(map, markNames.warranty);
  }
  if (request.garantyId === 2) {
    increaseValue(map, markNames.possWarranty);
  }
  if (request.isChargeable) {
    increaseValue(map, markNames.isChargeable);
  }
  if (request.isImmediate) {
    increaseValue(map, markNames.isImmediate);
  }
  if (request.isRetry) {
    increaseValue(map, markNames.isRetry);
  }
  if (request.isInternal) {
    increaseValue(map, markNames.isInternal);
  }

  if (diff > 0) {
    increaseValue(map, markNames.expired);
  }
};
